import React from "react";

import Dropzone from "react-dropzone";

const DropzoneButton = ({
  style,
  children,
  accept,
  onDrop,
  onPress,
  maxSize = null
}) => {
  return (
    <Dropzone
      onClick={ev => {
        if (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        }

        if (onPress) {
          onPress();
        }
      }}
      style={{ ...style, border: "none" }}
      accept={accept}
      onDrop={onDrop}
    >
      {children}
    </Dropzone>
  );
};

export { DropzoneButton };
